const state = {
  currentBarName: 'home',
  currentGoodsType: {
    showCategoryId: '',
    showCategoryName: ''
  },
  storeStatus: 1
}
const getters = {
  getCurrentBarName (state) {
    return state.currentBarName
  },
  getCurrentGoodsType (state) {
    return state.currentGoodsType
  },
  getStoreStatus (state) {
    return state.storeStatus
  }
}
const actions = {
  // fetchParams ({state, commit}, item) {
  //   commit('setParams', item)
  // }
}
const mutations = {
  setCurrentBarName (state, item) {
    state.currentBarName = item
  },
  setCurrentGoodsType (state, item) {
    state.currentGoodsType = item
  },
  setStoreStatus (state, item) {
    state.storeStatus = item
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
